export {
  comparisonLabelsFor,
  comparisonOptionsFor,
  expressionFor,
  expressionOptions,
  getRemainingExpressions,
  hasPricingComparisons,
  isExhausted,
  isQuoteComparisonField,
  ownExpressionOf,
  parseExpression,
  ATTACHMENTS_COMPARISON_LABELS,
  DEFAULT_SUB_OPERATOR,
  PAYMENT_TERMS_COMPARISON_LABELS,
  QUOTE_COMPARISON_FIELDS,
  type QuoteComparisonField
} from './comparisonExpressions'
